import type { AccountLanguage, AppViewDescriptor } from "./account";
import type { HttpClient } from "./http";

export interface ProfileUpdateRequest {
  /** Omit to leave unchanged. */
  language?: AccountLanguage;
  /**
   * Base64 image bytes, no `data:` prefix. Omit to leave the picture alone;
   * pass an empty string to remove it. The two are different intentions and
   * the endpoint treats them differently.
   */
  avatar?: string;
}

/**
 * The self-service half of the account API.
 *
 * Separate from the generic `ResourceClient<AccountDTO>` on purpose: that one
 * PUTs the whole record, which the server only lets an administrator do, and
 * which would carry the password hash and account level along with it. This
 * endpoint names the two fields a person may change about themselves, so a
 * USER-level account can reach it.
 */
export class AccountClient {
  constructor(private readonly http: HttpClient) {}

  async updateProfile(accountId: number, request: ProfileUpdateRequest): Promise<void> {
    await this.http.post<void>(`/account/${accountId}/profile`, request, { responseType: "void" });
  }

  /** Every view this app can grant, for the users screen's picker. */
  views(): Promise<AppViewDescriptor[]> {
    return this.http.get<AppViewDescriptor[]>("/account/views");
  }
}
